import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-least-performing-industry',
  templateUrl: './least-performing-industry.component.html',
  styleUrls: ['./least-performing-industry.component.css']
})
export class LeastPerformingIndustryComponent implements OnInit {

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  route:string;
  industryList = [];
  industryListLoader = false;
  userData:any = [];
  userName = null;
  userLevel = null;
  vendor_id = 0;
  public state: string = environment.state;

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level']

      if(this.userLevel == 'vendor'){
        this.vendor_id = this.userData['id'];
      }
    }

    this.getIndustryList();

  }

  getIndustryList(){

    this.industryListLoader = true;
    this.route  = 'get-least-performing-industry-list';
    const token = localStorage.getItem('userToken');

    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id};
    }else {
      data = {'user_id':this.userName,'user_level':this.userLevel};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.industryList = response.data;
      }
      this.industryListLoader = false;
    });

  }

}
